import { defineComponent as _defineComponent } from 'vue'
import Input from '@/components/ui/input/Input.vue'
import Dropdown from '@/components/ui/dropdown/Dropdown.vue'
import Checkbox from '@/components/ui/checkbox/Checkbox.vue'
import Button from '@/components/ui/button/Button.vue'
import { computed, inject, onBeforeMount } from 'vue'
import { NotifiedUserViewModel } from '../viewmodels/NotifiedUser.viewmodel'
import { NotificationChannelEnum } from '@/@core/fire-risk-settings/domain/enums/NotificationChannel.enum'
import HelpTooltip from '@/@web/ui/components/HelpTooltip.vue'
import TelegramLinkQrCode from './TelegramLinkQrCode.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NotifiedUserForm',
  setup(__props) {

const vm = inject<NotifiedUserViewModel>('notified-user-view-model') as NotifiedUserViewModel

function setPhoneNumber(value: string) {
	vm.notifiedUser.value.phoneNumber = value.replace(/[^0-9]/g, '')
}

const title = computed(() =>
	vm.notifiedUser.value.id
		? 'Editar Usuário de Alerta de Incêndio'
		: 'Cadastrar Usuário de Alerta de Incêndio',
)

onBeforeMount(() => vm.getMonitoredAreas())

return { __sfc: true,vm, setPhoneNumber, title, Input, Dropdown, Checkbox, Button, NotificationChannelEnum, HelpTooltip, TelegramLinkQrCode }
}

})